import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig({
    name: 'assetdirectory',
    cache: {
        ttl: 15000
    }
})
export class AssetDirectoryStore extends BaseStore {
    constructor() {
        super();
    }
}
